<template>
    <div v-show="conferenceRooms.length > 0" class="bg-white">

        <div id="conference_room_map" style="height:400px;" class="w-full"></div>

        <div class="flex justify-center">
            <div class="flex mx-4 items-center">
                <div class="w-4 h-4 rounded-full mr-2 bg-green-500"></div>
                verfügbar
            </div>
            <div class="flex mx-4 items-center">
                <div class="w-4 h-4 rounded-full mr-2 bg-red-500"></div>
                nicht verfügbar
            </div>
        </div>

    </div>
</template>

<script>
import L from "leaflet";

export default {
    name: "ConferenceRoomNavigation",

    props: {
        items: {
            type: Array,
            default: () => ([]),
        },
        unavailable: {
            type: Array,
            default: () => ([]),
        },
        value: {
            type: Array,
            default: () => ([]),
        }
    },

    watch: {
        items() {
            this.init();
        },
        value() {
            this.init();
        },
    },

    data: () => ({
        map: null,
    }),

    computed: {
        selected() {
            if (!this.selectedId) {
                return null;
            }
            return this.items.find(item => item.id === this.selectedId);
        },
        image() {
            if (!this.items[0] || !this.items[0].floor) {
                return '';
            }

            return this.items[0].floor.map_link;
        },
        conferenceRooms() {
            return this.items.filter(cr => cr.position);
        },
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            if (this.map != null) {
                this.map.remove();
                this.map = null;
            }

            let img = new Image();

            img.onload = () => {
                let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );

                this.map = L.map('conference_room_map', {
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.25,
                    zoomControl: false,
                });

                this.createMap(img.width, img.height)
            }

            img.src = this.image;
        },
        createMap(width, height) {
            let bounds = [[0, 0], [height, width]];
            L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);

            this.map.fitBounds(bounds);

            this.add();
        },
        add() {
            this.items.forEach(item => {
                this.addClickableRectangle(item);
            })
            this.addUnavailable();
        },
        setZoomFavorites() {
            this.setZoomItems(this.conferenceRooms.filter(cr => cr.is_favorite));
        },
        setZoom() {
            this.setZoomItems(this.conferenceRooms);
        },
        setZoomItems(items) {
            if (items.length === 0) {
                return;
            }

            let [l, t] = items[0].position.center;
            let [r, b] = items[0].position.center;

            items.forEach(cr => {
                l = Math.min(l, cr.position.center[0]);
                b = Math.min(b, cr.position.center[1]);
                r = Math.max(r, cr.position.center[0]);
                t = Math.max(t, cr.position.center[1]);
            });

            // look around zoom
            let w = 0;
            items.forEach(cr => {
                w = Math.max(w, cr.position.height, cr.position.width, cr.position.radius);
            });
            w *= 5;

            this.map.fitBounds([
                [l - w, t + w],
                [r + w, b - w]
            ]);
        },
        addUnavailable() {
            this.unavailable.forEach(item => {
                if (!item.position) {
                    return;
                }
                if (item.position.type === 'circle') {
                    L.circle(item.position.center, {color: "red", radius: item.position.radius, weight: 1})
                        .addTo(this.map);

                    return;
                }

                L.rectangle([
                    [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                ], {color: "red", weight: 1})
                    .addTo(this.map);
            })
        },
        isSelected(id) {
            return this.value.includes(id);
        },
        addClickableRectangle(item) {
            if (!item.position) {
                return;
            }

            let layer;

            const color = this.isSelected(item.id) ? 'blue' : "#10B981";

            if (item.position.type === 'circle') {
                layer = L.circle(item.position.center, {
                    color: color,
                    radius: item.position.radius,
                    weight: 1,
                    id: item.id
                });
            } else {
                layer = L.polygon([
                    [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                    [item.position.center[0] + item.position.height, item.position.center[1] + item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] - item.position.width],
                ], {
                    color: color,
                    weight: 1,
                    id: item.id
                });
            }

            layer
                .addTo(this.map)
                .on('click', (e) => {
                    this.toggle(e.target.options.id);
                });
        },
        toggle(id) {
            this.$emit('toggle', id);
        }

    }
}
</script>

<style scoped>
#map {
    background: white;
}
</style>
